import React, { useState, useEffect, useRef } from 'react';

export const EMOJI_CATEGORIES: Record<string, string[]> = {
    '😀': ['😀','😁','😂','🤣','😃','😄','😅','😆','😉','😊','😋','😎','😍','🥰','😘','😗','🤩','🥳','😏','😒','😞','😔','😟','😕','🙁','☹️','😣','😖','😫','😩','🥺','😢','😭','😤','😠','😡','🤬','🤯','😳','🥵','🥶','😱','😨','😰','😥','😓'],
    '👍': ['👍','👎','👌','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','👇','☝️','👋','🤚','🖐️','✋','🖖','🤜','🤛','👊','✊','🤝','👏','🙌','🤲','🙏','✍️','💪','🦾','🦿','💅','🤳'],
    '❤️': ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','💟','☮️','✝️','☯️','🕉️','✡️','🔯','🛐','☦️','🌈','🔥','⭐','✨','💫','💥','🎉','🎊','🎈','🎁','🏆','🥇','💰','💎'],
    '🐶': ['🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯','🦁','🐮','🐷','🐸','🐵','🙈','🙉','🙊','🐔','🐧','🐦','🦆','🦅','🦉','🦇','🐺','🐗','🐴','🦄','🐝','🐛','🦋','🐌','🐞','🐜','🦟','🦗','🕷️','🦂','🐢','🐍','🦎','🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐡','🐠','🐟','🐬','🐳','🐋','🦈'],
    '🍎': ['🍎','🍊','🍋','🍇','🍓','🫐','🍈','🍑','🍒','🍍','🥭','🍌','🍉','🍑','🍆','🥑','🥦','🥬','🥒','🌽','🥕','🧅','🧄','🥔','🍠','🌰','🥜','🍞','🥐','🥖','🥨','🧀','🥚','🍳','🧈','🥞','🧇','🥓','🌭','🍔','🍟','🍕','🥪','🥙','🧆','🌮','🌯','🍱','🍘','🍙','🍚','🍛','🍜','🍝','🍠','🍢','🍣','🍤','🍥','🥮','🍡','🧁','🎂','🍰','🍦','🍧','🍨','🍩','🍪','☕','🍺','🥂','🍾'],
    '⚽': ['⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱','🪀','🏓','🏸','🏒','🥅','⛳','🪁','🏹','🎣','🤿','🎽','🎿','🛷','🥌','🎯','🎮','🕹️','🎲','♟️','🎭','🎨','🎬','🎤','🎧','🎷','🎸','🎹','🎺','🎻','🥁','🪘'],
    '🌍': ['🌍','🌎','🌏','🗺️','🧭','🌋','🏔️','⛰️','🏕️','🏖️','🏜️','🏝️','🏞️','🏟️','🏛️','🏗️','🏘️','🏙️','🏚️','🏠','🏡','🏢','🏣','🏤','🏥','🏦','🏨','🏩','🏪','🏫','🏬','🏭','🏯','🏰','💒','🗼','🗽','🗾','🎌','⛩️','🌁','🌃','🌄','🌅','🌆','🌇','🌉','♨️','🌌','🌠','🎇','🎆','🌈','🌤️','⛅','🌥️','🌦️','🌧️','⛈️','🌩️','🌨️','❄️','🌬️','💨','🌀','🌊','💧','💦','☔','⚡','🌟'],
    '💼': ['💼','👜','👝','🎒','🧳','👒','🎩','🪖','⛑️','👑','💍','💎','👓','🕶️','🥽','🌂','☂️','🧵','🧶','👔','👗','👘','🥻','🩱','🩲','🩳','👙','👚','🧥','🥼','👛','🧤','🧣','🎀','👠','👡','👢','👞','👟','🥾','🥿','🧦'],
};

export function EmojiPicker({ onSelect, onClose, direction = "up" }: { onSelect: (e: string) => void; onClose: () => void; direction?: "up" | "down" }) {
    const categories = Object.keys(EMOJI_CATEGORIES);
    const [activeCategory, setActiveCategory] = useState(categories[0]);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) onClose();
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [onClose]);

    return (
        <div
            ref={ref}
            className={`absolute ${direction === "up" ? "bottom-full mb-2" : "top-full mt-2"} left-0 w-72 bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-gray-100 dark:border-slate-700 overflow-hidden z-50 animate-in slide-in-from-bottom-2`}
            style={{ boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}
        >
            {/* Category tabs */}
            <div className="flex items-center gap-0.5 px-2 pt-2 pb-1 border-b border-gray-100 dark:border-slate-700 overflow-x-auto no-scrollbar">
                {categories.map(cat => (
                    <button
                        key={cat}
                        type="button"
                        onClick={() => setActiveCategory(cat)}
                        className={`text-lg px-1.5 py-1 rounded-lg transition-all flex-shrink-0 ${
                            activeCategory === cat
                                ? 'bg-green-100 dark:bg-green-900/40 scale-110'
                                : 'hover:bg-gray-100 dark:hover:bg-slate-700'
                        }`}
                    >
                        {cat}
                    </button>
                ))}
            </div>
            {/* Emoji grid */}
            <div className="grid grid-cols-8 gap-0.5 p-2 max-h-52 overflow-y-auto">
                {EMOJI_CATEGORIES[activeCategory].map((emoji, i) => (
                    <button
                        key={i}
                        type="button"
                        onClick={() => onSelect(emoji)}
                        className="text-xl p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-all hover:scale-125 active:scale-95"
                    >
                        {emoji}
                    </button>
                ))}
            </div>
        </div>
    );
}
